var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14","stroke":"none"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.33863 0.75415L4.51367 1.57911L9.93453 6.99996L4.51367 12.4208L5.33863 13.2458L11.5844 6.99996L5.33863 0.75415Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }